import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-white via-gray-50 to-gray-100 py-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium">
                <Icon name="Award" size={16} strokeWidth={2} />
                <span>About Kharbanda Motors</span>
              </div>

              <h1 className="text-4xl font-bold text-text-primary leading-tight">
                Transforming India's Auto Parts Industry
                <span className="text-accent block">Since 1984</span>
              </h1>

              <p className="text-lg text-text-secondary leading-relaxed">
                From a modest workshop in Prayagraj to one of India’s most
                trusted platforms for car spare parts, automobile parts, and car
                accessories Kharbanda Motors has been shaping the way how car
                owners and workshops find reliable, compatible, and genuine
                spare parts for their vehicles.
                <br />
                <br />
                With over 40 years of excellence, we’ve built an extensive
                network of verified genuine and OEM parts suppliers, certified
                dealers, and quality-tested aftermarket manufacturers, ensuring
                every customer receives genuine and reliable car parts backed by
                uncompromising service.
              </p>
            </div>

            {/* Mission Statement */}
            <div className="bg-white p-6 rounded-lg shadow-automotive-sm border border-border">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                  <Icon
                    name="Target"
                    size={24}
                    color="var(--color-accent)"
                    strokeWidth={2}
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-text-primary mb-2">
                    Our Vision
                  </h3>
                  <p className="text-text-secondary">
                    To continue leading India’s transformation in the automotive
                    service and spare parts sector by providing genuine,
                    reliable, and affordable genuine car parts accessible to
                    every vehicle owner and workshop across the nation.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-automotive-lg">
              <Image
                src="KM-logo.webp"
                alt="Modern automotive workshop with organized parts inventory"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
